import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import { request } from "@/js/http/http_request";
import { defaultPagingChoices } from "@/js/lists.ts";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
export default {
  name: "ProducerList",
  components: {
    paging: pagingComponent,
    index: indexComponent
  },
  props: {
    loggedUserData: Object,
    type: String
  },
  data: function data() {
    return {
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Name",
        align: "start",
        value: "name"
      }, {
        text: "Email",
        align: "center",
        value: "logisticEmail"
      }, {
        text: "SKU acronym",
        align: "center",
        value: "skuAcronym"
      }, {
        text: "Links",
        value: "link",
        sortable: false
      }],
      baseModel: {
        items: [],
        numberOfProducers: 0,
        numberOfPages: 0
      },
      searchCriterias: {
        label: "",
        isWinery: null,
        isDistillery: null,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      pagingLimitsChoices: defaultPagingChoices
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.datatable_loading && this.baseModel.numberOfProducers > 0;
    },
    isWinery: function isWinery() {
      return this.type == "wineries";
    },
    isDistillery: function isDistillery() {
      return this.type == "distilleries";
    },
    labelProducers: function labelProducers() {
      if (this.isWinery) return "wineries";
      if (this.isDistillery) return "distilleries";
      return "producers";
    },
    labelProducer: function labelProducer() {
      if (this.isWinery) return "winery";
      if (this.isDistillery) return "distillery";
      return "producer";
    }
  },
  watch: {
    type: function type(newVal, oldVal) {
      this.search(true);
    }
  },
  created: function created() {
    this.search(true);
  },
  methods: {
    canManage: function canManage() {
      var hasRoleManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRODUCERS);
      return hasRoleManage;
    },
    goToWineList: function goToWineList(id) {
      var detailsRoute = "adminProductList";
      var tab = "wines";
      if (this.isDistillery) tab = "spirits";
      return {
        name: detailsRoute,
        query: {
          tab: tab,
          producer: id.toString()
        }
      };
    },
    goToProducerDetails: function goToProducerDetails(id) {
      var detailsRoute = "";
      var returnRoute = "";
      if (this.loggedUserData.userGroup == "ADMIN") {
        detailsRoute = "adminProducerDetails";
        returnRoute = "adminProducerList";
      } else {
        detailsRoute = "userProducerDetails";
        returnRoute = null;
      }
      return {
        name: detailsRoute,
        params: {
          id: +id,
          isWinery: this.isWinery,
          isDistillery: this.isDistillery,
          returnRoute: returnRoute
        }
      };
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isResetPaging) {
        this.searchCriterias.isWinery = null;
        this.searchCriterias.isDistillery = null;
        if (this.isWinery) this.searchCriterias.isWinery = true;
        if (this.isDistillery) this.searchCriterias.isDistillery = true;
      }
      this.$EventBus.$emit("loading", true);
      var _this = this;
      document.body.style.cursor = "wait";
      _this.datatable_loading = true;
      if (isResetPaging) _this.resetPaging();
      request("/v1/producers/all", "post", _this.searchCriterias, true, "api").then(function (response) {
        _this.baseModel.items.splice(_this.searchCriterias.paging.limits);
        _this.baseModel = {
          items: response.data.value.items,
          numberOfProducers: response.data.value.total_number,
          numberOfPages: Math.ceil(response.data.value.total_number / _this.searchCriterias.paging.limits)
        };
        _this.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
        if (!_this.searchCriterias.paging.currentPage) {
          _this.searchCriterias.paging.currentPage = 0;
        }
        _this.datatable_loading = false;
        document.body.style.cursor = "default";
        _this.$EventBus.$emit("loading", false);
      }).catch(function (_) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        document.body.style.cursor = "default";
        _this.datatable_loading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};